import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ICartState {
	meals: any[];
	total: number;
}

const initialState: ICartState = {
	meals: [],
	total: 0,
}

const cartSlice = createSlice({
	name: 'cart',
	initialState,
	reducers: {
		setCartValue: <T extends keyof ICartState>(state: ICartState, action: PayloadAction<{ key: T, value: ICartState[T] }>) => {
			const { key, value } = action.payload;
			state[key] = value;
		},
	}
});

export const { setCartValue } = cartSlice.actions;

export default cartSlice.reducer;